<template>
  <div id="myaccount">
    <div class="rechage_wrapper">
      <div class="header_wrapper">
        <div class="header_info">
          <el-row>
            <el-col :span="2">
              <div class="portrait">
                <!-- <el-avatar src="../assets/img/portrait.png" :size="80"></el-avatar> -->
                <img width="80px" src="../assets/img/portrait.png" >
              </div>
            </el-col>
            <el-col :span="22">
              <div class="header_right content-flex">
                <p class="center-nickname">{{$t('pc.myaccount.hello_danniu_securities_member')}}</p>
                <i class="line"></i>
                <p class="last-time">{{$t('pc.myaccount.user_name')}}： {{ phone }} |  {{$t('pc.myaccount.last_login_time')}}：{{$getDeviceTime( time) }}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="recharge_content">
        <ul class="recharge_right">
          <li @click="changeAccount(1)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==1 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/rechange"><i class="el-icon-user">{{$t('pc.capital.myaccount')}}</i></router-link>
          </li>
          <li @click="changeAccount(2)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==2 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/risk_control"><i class="el-icon-warning">{{$t('pc.myaccount.risk_control_notification')}}</i></router-link>
          </li>
          <li v-if="gxpayStatus == 1" @click="changeAccount(15)" style="text-align:left;padding-left: 35px;cursor: pointer;" :class="$store.state.accountType ==15 ? 'recharge_li_active' : '' ">
            <i class="el-icon-money">Gxpay</i>
          </li>
           <li v-if="central_ucenter_transfer_status == 1" @click="changeAccount(17)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==17 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/platform_transfer"><i class="el-icon-guide">{{$t('pc.myaccount.platform_transfer')}}</i></router-link>
          </li>
          <li @click="changeAccount(3)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==3 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/strategynow"><i class="el-icon-s-data">{{$t('pc.myaccount.financing_account')}}</i></router-link>
          </li>
          <li @click="changeAccount(4)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==4 ? 'recharge_li_active' : '' ">
            <router-link to="/stockdetailed?symbol=usNVDA&direction=0"><i class="el-icon-s-marketing">{{$t('pc.header.real_transaction')}}</i></router-link>
          </li>
          <li @click="changeAccount(5)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==5 ? 'recharge_li_active' : '' ">
            <router-link to="/stockdetailed?symbol=usNVDA&direction=1"><i class="el-icon-s-management">{{$t('pc.header.short_trade')}}</i></router-link>
          </li>
          <li @click="changeAccount(6)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==6 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/capital"><i class="el-icon-money"></i>{{$t('pc.myaccount.fund_operations')}}</router-link>
          </li>
          <li @click="changeAccount(7)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==7 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/trading_query"><i class="el-icon-s-claim"></i>{{$t('pc.myaccount.trading_inquiry')}}</router-link>
          </li>
          <li @click="changeAccount(8)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==8 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/friend_coupon"><i class="el-icon-suitcase"></i>{{$t('pc.myaccount.friend_cash_coupons')}}</router-link>
          </li>
          <li @click="changeAccount(9)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==9 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/usercoupon"><i class="el-icon-suitcase"></i>{{$t('pc.myaccount.my_cash_coupons')}}</router-link>
          </li>
          <li @click="changeAccount(10)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==10 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/detailed"><i class="el-icon-s-order"></i>{{$t('pc.myaccount.funding_details')}}</router-link>
          </li>
          <li @click="changeAccount(11)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==11 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/information"><i class="el-icon-setting"></i>{{$t('pc.myaccount.complete_information')}}</router-link>
          </li>
          <li @click="changeAccount(12)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType ==12 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/agency"><i class="el-icon-thumb"></i>{{$t('pc.myaccount.agency_account')}}</router-link>
          </li>
          <!-- <li v-if="financeStatus == 1" @click="changeAccount(13)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType == 13 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/finance_fund"><i class="el-icon-suitcase"></i>{{$t('pc.myaccount.regular_treasure')}}</router-link>
          </li>
          <li v-if="holidayStatus == 1" @click="changeAccount(14)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType == 14 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/holiday_fund"><i class="el-icon-suitcase"></i>{{$t('pc.myaccount.holiday_treasure')}}</router-link>
          </li> -->
          <li v-if="timebaoStatus == 1" @click="changeAccount(16)" style="text-align:left;padding-left: 35px;" :class="$store.state.accountType == 16 ? 'recharge_li_active' : '' ">
            <router-link to="/myaccount/timebao"><i class="el-icon-suitcase"></i>{{$t('pc.myaccount.shishi_bao')}}</router-link>
          </li>
          <li style="text-align:left;padding-left: 35px;"><i class="el-icon-suitcase"></i>{{$t('pc.myaccount.version_number')}} : {{ version }}</li>
<!--          <li @click="changeAccount(12)" :class="$store.state.accountType == 12 ? 'recharge_li_active' : '' ">-->
<!--            <router-link to="/myaccount/friend_coupon"><i class="el-icon-suitcase"></i>好友现金券</router-link>-->
<!--          </li>-->
<!--          <li @click="changeAccount(13)" :class="$store.state.accountType == 13 ? 'recharge_li_active' : '' ">-->
<!--            <router-link to="/myaccount/usercoupon"><i class="el-icon-suitcase"></i>我的现金券</router-link>-->
<!--          </li>-->
        </ul>
          <router-view name="kids"></router-view>
      </div>
    </div>
    <keep-alive>
    </keep-alive>
  </div>
</template>
<script>
import { version } from './../../package.json'
import "./../assets/css/account.css";
import "./../assets/css/deal.css";
export default {
  name: "Myaccount",
  data(){
    return{
      version: version,
      phone:'',
      timebaoStatus:0,
      financeStatus:0,
      holidayStatus:0,
      time:'',
      central_ucenter_transfer_status:0,
      gxpayStatus: 0,
    }
  },
  components: {
  },
  mounted() {
    this.isLogin();
    this.getUserinfo();
    this.getCentralTransferStatus();
  },
  methods: {
      getCentralTransferStatus() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "sysconfig",
            token: sessionStorage.getItem("token"),
            name: "central_ucenter_transfer_status",
          },
        })
        .then(function (res) {
          let resData = res.data;
          if (res.data.code === 1) {
            let resData = res.data;
            that.central_ucenter_transfer_status = resData.data;
          } else if (res.data.code === 0 || res.data.code === -1) {
            that.$toast.fail(that.$t(resData.msg));
          }
        });
    },
    isLogin(){
      if (!this.$store.state.loginType){
        this.$router.push({
          path: "/login"
        });
      }
    },
    changeAccount(type) {
      window.sessionStorage.setItem("accountType", type);
      this.$store.state.accountType = type;
      if(type == 15){
        let that = this;
        that
          .$http({
            url: "/",
            method: "POST",
            data: {
              nozzle: "gxpay_thirdparty_digital_currency",
              token: sessionStorage.getItem("token"),
            },
          })
          .then((ret) => {
            let resData = ret.data;
            if (resData.code == 1) {
              if(resData.data.user == true){
                this.$router.push("/myaccount/gxpay");
              }
              else{
                this.$router.push("/myaccount/rechange");
                this.$store.accountType=1;
                window.open(resData.data.homeUrl,'_blank');
              }
            }
          });
      }else if(type == 12) {
        window.location.reload();
        this.$router.push({
          path: "/myaccount/agency"
        });
      }
    },
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "user",
            token: sessionStorage.getItem("token")
          }
        })
        .then(function(res) {
          if (res.data.code == 1) {
            that.phone = res.data.data.phone;
            that.time = res.data.data.time;
            that.timebaoStatus = res.data.data.timebao_status;
            that.financeStatus = res.data.data.finance_status;
            that.holidayStatus = res.data.data.holiday_status;
            that.gxpayStatus = res.data.data.gxpaymenu_status;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msg));
          }
        });
    },
  }
};
</script>
<style scoped>
@import url("./../assets/css/account.css");
@import url("./../assets/css/deal.css");
*{
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
}
  .header_wrapper{
    height: 100px;
    width: 100%;
    background-color: #e35353;
    margin-bottom: 10px;
  }
  .header_info{
    min-width: 1000px;
    max-width: 1200px;
    margin: 0 auto;
    height: 100%;
  }
  .portrait{
    margin-top: 10px;
  }
  .header_right{
    color: white;
    height: 100px;
  }
  .line{
    display: block;
    width: 100%;
    height: 1px;
    background: url(../assets/img/line.png) no-repeat;
  }
  .center-nickname{
    font-size: 18px;
    padding-bottom: 10px;
  }
  .last-time{
    padding-top: 10px;
    font-size: 14px;
  }
  .content-flex{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/components/myaccount.vue